import { fromFetch } from 'rxjs/fetch';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { ignoreData } from '../../../utils/ignore-data';
import { authwsEnvironment } from '../authws-environment';

/**
 * Accept the current terms of use for the current authenticated user
 * @param product Name of the Trimble Maps Product
 * @param accountId Id of the Account
 * @param version Version of the terms to agree to (Defaults to 1)
 */
export function postProductAccountUserTerms(
  this: unknown,
  product: string,
  accountId: number,
  version = 1
) {
  return fromFetch(
    new Request(
      `${authwsEnvironment.resolve(this).productsUrl}/${encodeURIComponent(
        product
      )}/accounts/${encodeURIComponent(accountId)}/users/me/terms`,
      {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
        body: JSON.stringify({ version }),
      }
    )
  ).pipe(ignoreData());
}
